<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block" style="display:flex">
        <div class="block" style="margin-left:20px;display:flex">
          <el-input placeholder="输入关键字模糊查询" v-model="keywordQuery" clearable></el-input>
          <el-select style="margin-left: 10px" v-model="stateVal" clearable placeholder="推送状态">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>

        <el-dialog title="新建信息 " :visible.sync="dialogBigScreen">
          <el-form :model="form">
            <el-form-item label="信息内容：" label-width="120px">
              <el-row>
                <el-col :span="20">
                  <el-input type="textarea" rows="5" v-model="form.sms_content" resize="none"></el-input>
                </el-col>
              </el-row>
            </el-form-item>

             <el-form-item label="推送时间：" label-width="120px">
              <el-row>
                <el-col :span="10">
                  <el-date-picker
                    style="width: 100%"
                    v-model="form.send_time"
                    type="datetime"
                    placeholder="选择日期时间">
                  </el-date-picker>
                </el-col>
              </el-row>
            </el-form-item>

            <el-form-item label="推送目标：" label-width="120px">
              <el-row>
                <el-col :span="10">
                  <el-select style="width: 100%" v-model="form.sms_group_id" multiple collapse-tags clearable  placeholder="请选择">
                    <el-option
                      v-for="item in groups"
                      :key="item.id"
                      :label="item.title"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogBigScreen = false">取 消</el-button>
            <el-button type="primary" @click="editTurn == 1 ?editSaveFn():smsAdd()">确 定</el-button>
          </div>
        </el-dialog>

        <div style="margin-left:20px">
          <el-row>
            <el-button type="success" @click="queryData()">查询</el-button>
            <el-button type="primary" @click="dialogBigScreen = true ">新建信息</el-button>
          </el-row>
        </div>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        :default-sort="{prop: 'date', order: 'descending'}"
      >
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="sms_content" label="信息内容"></el-table-column>
        <el-table-column prop="sms_group_id" label="推送目标">
          <template slot-scope="scope">
            <span v-for="(item,index) in scope.row.sms_group" :key="index">/{{item.title}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="add_time" label="创建时间" :formatter="addTime" sortable></el-table-column>
        <el-table-column prop="send_time" label="推送时间">
          <template slot-scope="scope">
            {{timestampToTime(scope.row.send_time)}}
          </template>
        </el-table-column>
       <el-table-column prop="status" label="推送状态">
         <template slot-scope="scope">
           {{scope.row.status == 0? "未推送": scope.row.status == 1? "推送中": scope.row.status == 2? "已推送" : ""}}
         </template>
       </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-row>
              <el-button type="text" size="small" @click="editFn(scope.row)">
                <i class="el-icon-edit"></i>编辑
              </el-button>
              <el-button type="text" size="small" @click="deleteFn(scope.row)">
                <i class="el-icon-delete"></i>删除
              </el-button>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalList"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import api from "./api";
import {timestampToTime} from "@/mixins/tools.js"

export default {
  mixins: [timestampToTime],
  name: "CountryBase",
  data() {
    return {
      editTurn: "",
      loading: false,
      keywordQuery: "",
      stateVal: "",
      tableData: [],
      currentPage: 1,
      totalList: null,
      dialogBigScreen: false,
      form: {
        
      },
      options: [{
          value: '0',
          label: '未推送'
        },{
          value: '1',
          label: '推送中'
        }, {
          value: '2',
          label: '已推送'
        }
      ],
      groups: []
    };
  },
  created() {
    this.getData();
    this.userList()
  },
  methods: {
    // 获取数据
    getData() {
      this.loading = true;
      let datas;
      if(this.keywordQuery == "" && this.stateVal == "") {

      }else {
        datas = {
          q: this.keywordQuery,
          status: this.stateVal
        }
      }
      
      api
        .smsList(datas)
        .then(res => {
          this.loading = false
          this.tableData = res.list;
          this.totalList = res.recordcount;
          this.pageSize = res.pagecount;
        })
        .catch(err => {
          this.$message(err);
        });
    },

    // 用户组列表
    userList() {
      api.userList()
      .then(res => {
        this.groups = res.list
      })
      .catch(err => {
        
      });
    },

    // 新增信息
    smsAdd() {
      let ids="";
      if(this.form.sms_group_id.length > 0) {
        for(let i = 0; i < this.form.sms_group_id.length; i++) {
          ids += this.form.sms_group_id[i] + ","
        }
        this.form.sms_group_id = ids.substring(-1,ids.length-1)
      }else {
        this.form.sms_group_id = "-1"
      }
      
      this.form.send_time = new Date(this.form.send_time).getTime() / 1000
      api
        .smsAdd(this.form)
        .then(res => {
          this.$message.success("提交成功！");
          this.getData();
          this.dialogBigScreen = false;
          this.form = {}
        })
        .catch(err => {
        });
    },

    // 编辑保存
    editSaveFn() {
      let ids="";
      if(this.form.sms_group_id.length > 0) {
        for(let i = 0; i < this.form.sms_group_id.length; i++) {
          ids += this.form.sms_group_id[i] + ","
        }
        this.form.sms_group_id = ids.substring(-1,ids.length-1)
      }else {
        this.form.sms_group_id = "-1"
      }
      this.form.send_time = new Date(this.form.send_time).getTime() / 1000
      console.log(this.form)
      api
        .editSave(this.form)
        .then(res => {
          this.$message.success("修改成功！");
          this.getData();
          this.dialogBigScreen = false;
          this.form = {}
        })
        .catch(err => {
        });
    },

     // 删除
    deleteFn(row) {
      let datas = {
        id: row.id
      }
      this.$confirm('确定要删除吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
         api.deleteFn(datas)
          .then(res => {
            if(res.error_code == 0) {
              this.$message.success("删除成功！")
            }
            this.getData()
          })
          .catch(err => {
            
          });
      }).catch(() => {
      });
    },


    // 编辑操作
    editFn(row) {
      this.editTurn = 1
      this.dialogBigScreen = true
      let datas = {
        id: row.id
      }
      api.editInfo(datas)
      .then(res => {
        this.form = res.info
        this.form.send_time = this.form.send_time * 1000
        this.form.sms_group_id = this.form.sms_group_id.split(",").map(parseFloat)
      })
      .catch(err => {
        
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  text-align: right;
  padding: 0 20px;
}
.countryName {
  margin-right: 10px;
  width: 100px;
  justify-content: center;
  align-items: center;
  display: flex;
}
</style>